var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * Response of `GET /v1/office-locations/:officeLocationId/gkv-billing-run/in-flight`
 * — the resume-on-reopen lookup the §302 column performs on mount (TM-9538 / #1524).
 *
 * ⚠ **Cut on the Standort, not on the Mandant.** The Mahnlauf's equivalent takes
 * an `officeId` and walks the caller's allowed locations, because its sidebar is
 * opened per practice. A §302 run is a Standort-level thing all the way down —
 * the Absender, the in-flight lock and the Leistungserbringer-IKs all hang off
 * the Standort — and the column is already keyed by one, so there is nothing to
 * walk.
 *
 * `null` means nothing is running and the column shows the Kandidatenansicht.
 * A non-null id means a run is in flight and the column attaches to it instead
 * of offering to start a second one it could not start anyway: closing the
 * column never stopped the worker, because the run is backend-driven and this
 * is only a view onto it.
 */
export class InFlightGkvBillingRunResponseDto {
    gkvBillingRunId;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], InFlightGkvBillingRunResponseDto.prototype, "gkvBillingRunId", void 0);
//# sourceMappingURL=in-flight-gkv-billing-run.response.dto.js.map